import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    styleUrl: './loading-indicator.component.scss',
    standalone: false
})
export class LoadingIndicatorComponent {
  @Input() size: number = 30;
}
